module.exports = __webpack_public_path__ + "static/img/bannerVR.802846db.png";